import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const LegalLinksSeparator = (props) => {
    return (
        <Icon
            {...props}
            viewBox="0 0 8 10"
            data-testid="legal-links-seperator-icon"
            aria-hidden="true"
        >
            <rect width="1.5" height="10" rx="0.75" fill="#374B8A" />
            <rect x="3.25" width="1.5" height="10" rx="0.75" fill="#374B8A" />
            <rect x="6.5" width="1.5" height="10" rx="0.75" fill="#374B8A" />
        </Icon>
    )
}

LegalLinksSeparator.propTypes = {
    color: PropTypes.string,
}

export default LegalLinksSeparator
